import { set } from "@ember/object"
import Evented from "@ember/object/evented"
import Service from "@ember/service"

export default class ImportLessonsModal extends Service.extend(Evented) {
  openModal(dateString, course) {
    set(this, "isOpen", true)
    set(this, "dateString", dateString)
    set(this, "course", course)
    this.trigger("openModal", dateString, course)
  }
}
